import React from "react";

const PeriodCell = cellData => {
    return <div>
      {(cellData.key.dateBegin && cellData.key.dateEnd) ?
      <div>{cellData.key.dateBegin} - {cellData.key.dateEnd}</div> : <></>}
    </div>
};

export default PeriodCell;
